module.exports = __webpack_public_path__ + "img/zoll-x-series.db997981.jpg";